import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import classNames from 'classnames';

import styles from './DetailModal.module.scss';

interface IProps {
  name?: string;
  title?: string;
  description?: string;
  visible: boolean;
  onClose?: () => void;
}

function DetailModal(props: IProps) {
  const { name = '', title = '', description = '', visible, onClose } = props;

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Transition appear show={visible} as={Fragment}>
      <Dialog as="div" className={styles['modal-mask']} onClose={handleClose}>
        {/** 遮罩 */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#000] bg-opacity-70 opacity-100 lg:bg-opacity-70" />
        </Transition.Child>

        {/** 关闭按钮 */}
        {/* <div className={classNames(styles['close-btn'], styles['sm-close-btn'])} /> */}

        {/** 弹窗内容 */}
        <div className="fixed inset-0 overflow-y-auto pt-[60px] lg:pt-[80px]">
          <div className="flex min-h-full items-center justify-center text-center lg:py-[100px]">
            <Dialog.Panel className={styles.container}>
              <div className={classNames(styles['close-btn'])} onClick={handleClose} />
              <div className={styles.content}>
                <div className={styles.title}>{name}</div>
                <div className={styles.subTitle}>{title}</div>
                <div
                  className={styles.detail}
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default DetailModal;
